/* eslint no-unused-vars: ["error", { "args": "none" }] */

export class AudioPlayer {

	/**
	 * CURRENT TRACK
	 * currentTrackData: id, title, album etc tout ce qui concerne la track courante dapres lapi
	 * currentFileUrlData: getFileUrl du track (bit_depth, format_id, mime_type, restrictions, sampling_rate, track_id, url)
	 *
	 * NEXT TRACK
	 * nextTrackData: id, title, album etc.. de la prochaine track
	 * nextFileUrlData: getFileUrl de la prochaine track
	 * nextTrackPrepared: si la prochaine track est finie d'être préparée par un prepareNextTrack
	 */

	constructor() {
		/*if (new.target === AudioPlayer) {
		 throw new TypeError('Cannot construct AudioPlayer instances directly (abstract class)')
		 }*/

		this.currentTrackEndComing = false

		this.currentTrackData = null
		this.currentFileUrlData = null

		this.nextTrackData = null
		this.nextFileUrlData = null
		this.nextTrackPrepared = false
	}

	/**
	 * Callback émis au moment où une track est initialisée
	 * @param cb : Function
	 */
	setOnLoadedTrack(cb) {
		this.onLoadedTrack = () => {
			cb()
		}
	}

	/**
	 * Callback émis au moment de la lecture du morceau courant
	 * @param cb : Function
	 */
	setOnPlayedTrack(cb) {
		this.onPlayedTrack = () => {
			cb()
		}
	}

	/**
	 * Callback émis au moment de la pause/stop du morceau courant
	 * @param cb : Function
	 */
	setOnPausedTrack(cb) {
		this.onPausedTrack = () => {
			cb()
		}
	}

	/**
	 * Callback émis à chaque fois que le morceau courant bloque et commence à bufferiser
	 * @param cb : Function
	 */
	setOnBufferingTrack(cb) {
		this.onBuffering = () => {
			cb()
		}
	}

	/**
	 * Callback émis à chaque fois que le blocage de bufferisation est terminé
	 * @param cb : Function
	 */
	setOnBufferingEndedTrack(cb) {
		this.onBufferingEnded = () => {
			cb()
		}
	}

	/**
	 * Callback émis à chaque fois que le buffer de la track courrante change
	 * @param cb : Function | 1 paramètre : Array de [{start: x, end: y>x}, ...]
	 */
	setOnBufferChangedTrack(cb) {
		this.onBufferChanged = (buffers) => {
			cb(buffers)
		}
	}

	/**
	 * Callback émis au moment où le morceau courant a été complètement chargé en cache
	 * @param cb : Function
	 */
	setOnCacheComplete(cb) {
		this.onCacheComplete = () => {
			cb()
		}
	}

	/**
	 * Callback émis au moment où la track suivante a été préparée
	 * @param cb : Function
	 */
	setOnPreparedNextTrack(cb) {
		this.onPreparedNextTrack = () => {
			if (!this.nextTrackPrepared) {
				this.nextTrackPrepared = true
				cb()
			}
		}
	}

	/**
	 * Callback émis au moment où la track courante vient de passer instantanément à la suivante
	 * @param cb : Function | 1 paramètre : Boolean pour définir s'il a s'agit d'un switchToNext ou d'un nextTrack
	 */
	setOnSwitchedNextTrack(cb) {
		this.onSwitchedNextTrack = (switchedToNext) => {
			// equivalent à load(), plus bas
			this.currentTrackEndComing = false
			this.currentTrackData = Object.assign({}, this.nextTrackData)
			this.currentFileUrlData = Object.assign({}, this.nextFileUrlData)
			this.resetNextTrack()
			// callback une fois le switch effectué
			cb(switchedToNext)
		}
	}

	/**
	 * Callback émis à chaque seconde avancée dans la lecture
	 * @param cb : Function | 1 paramètre : Integer en secondes
	 */
	setOnProgressChanged(cb) {
		this.onProgressChanged = (position) => {
			cb(position)
		}
	}

	/**
	 * Callback émis une fois la fin bientôt arrivée. Utilise appConst.timeForGaplessPreload.
	 * @param cb : Function | Doit faire appel à prepareNextTrack
	 */
	setOnTrackEndComing(cb) {
		this.onTrackEndComing = () => {
			if (!this.currentTrackEndComing) {
				this.currentTrackEndComing = true
				this.prepareNextTrack(this.nextTrackData, this.nextFileUrlData)
				cb()
			}
		}
	}

	/**
	 * Callback émis à la fin de lecture du track courante
	 * @param cb : Function | Doit faire appel à switchNextTrack
	 */
	setOnTrackEnded(cb) {
		this.onTrackEnded = () => {
			cb()
		}
	}

	/* ************************************************************
	 ***************************************************************
	 ************************************************************ */

	/**
	 * Charge une musique en cache
	 * @param trackData : Object | Data de track depuis l'API, stockée en playqueue
	 * @param fileUrlData : Object, cf getFileUrl struct dans playerActions.js
	 * @param autoPlay : Boolean
	 * @param initialSeek: Integer | En secondes
	 * @param volume: Integer | Volume initial de 0 à 100
	 */
	load(trackData, fileUrlData, autoPlay, initialSeek, volume) {
		this.currentTrackEndComing = false
		this.currentTrackData = trackData
		this.currentFileUrlData = fileUrlData
		this.resetNextTrack()
	}

	/**
	 * Joue la musique courante
	 */
	play() {
	}

	/**
	 * Pause la musique courante
	 */
	pause() {
	}

	/**
	 * Stop la musique courante
	 */
	stop() {
	}

	/**
	 * Détruit le player
	 */
	closeMusic() {
	}

	/**
	 * Déplace l'écoute dans le morceau courant
	 * @param position: Integer | En secondes
	 * @return Boolean
	 */
	seek(position) {
	}

	/**
	 * Change le volume du lecteur
	 * @param volume: Integer | de 0 à 100
	 */
	setVolume(volume) {
	}

	/**
	 * Précharge une track dans le cache audio. Doit être appelé dans le callback onTrackEndComing
	 *
	 * @param trackData
	 * @param fileUrlData
	 */
	prepareNextTrack(trackData, fileUrlData) {
		this.nextTrackData = trackData
		this.nextFileUrlData = fileUrlData
	}

	resetNextTrack() {
		this.nextTrackData = null
		this.nextFileUrlData = null
		this.nextTrackPrepared = false
	}

	/**
	 * Lit instantanément la track suivante à la place de la courante, préablement "préparée" dans la méthode ci-dessus
	 *
	 * @return true si la track suivante est préparée et ca peut switch, false sinon
	 */
	switchNextTrack() {
	}

}



// WEBPACK FOOTER //
// ./src/components/miniPlayer/AudioPlayer/AudioPlayer.js